import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { MdKeyboardArrowRight } from 'react-icons/md';

import ROUTES from '../../routes';
import Link from '../Link';

import styles from './aside.module.css';

const AsideLearn = ({ className = '', data, withSectionsOnly = false }) => {
  const router = useRouter();
  const { id } = router.query;

  const [mysql, setMysql] = useState([]);
  const [postgresql, setPostgresql] = useState([]);
  const [bigquery, setBigquery] = useState([]);
  const [redshift, setRedshift] = useState([]);
  const [sqlserver, setSqlserver] = useState([]);
  const [snowflake, setSnowflake] = useState([]);

  const [openBigquery, setOpenBigquery] = useState(false);
  const [openMysql, setOpenMysql] = useState(false);
  const [openRedshift, setOpenRedshift] = useState(false);
  const [openPostgre, setOpenPostgre] = useState(false);
  const [openSqlserver, setOpenSqlserver] = useState(false);
  const [openSnowflake, setOpenSnowflake] = useState(false);

  const data_mysql = [[], [], [], []];
  const data_postgresql = [[], [], [], []];
  const data_bigquery = [[], [], [], []];
  const data_redshift = [[], [], [], []];
  const data_sqlserver = [[], [], [], []];
  const data_snowflake = [[], [], [], []];

  const toggleOpenRedshift = (forceOpen = false) => {
    setOpenBigquery(false);
    setOpenMysql(false);
    setOpenPostgre(false);
    setOpenRedshift(forceOpen === true ? true : !openRedshift);
    setOpenSqlserver(false);
    setOpenSnowflake(false);
  };

  const toggleOpenMysql = (forceOpen = false) => {
    setOpenBigquery(false);
    setOpenMysql(forceOpen === true ? true : !openMysql);
    setOpenPostgre(false);
    setOpenRedshift(false);
    setOpenSqlserver(false);
    setOpenSnowflake(false);
  };

  const toggleOpenBigquery = (forceOpen = false) => {
    setOpenBigquery(forceOpen === true ? true : !openBigquery);
    setOpenMysql(false);
    setOpenPostgre(false);
    setOpenRedshift(false);
    setOpenSqlserver(false);
    setOpenSnowflake(false);
  };

  const toggleOpenPostgre = (forceOpen = false) => {
    setOpenBigquery(false);
    setOpenMysql(false);
    setOpenPostgre(forceOpen === true ? true : !openPostgre);
    setOpenRedshift(false);
    setOpenSqlserver(false);
    setOpenSnowflake(false);
  };

  const toggleOpenSqlServer = (forceOpen = false) => {
    setOpenBigquery(false);
    setOpenMysql(false);
    setOpenPostgre(false);
    setOpenRedshift(false);
    setOpenSqlserver(forceOpen === true ? true : !openSqlserver);
    setOpenSnowflake(false);
  };

  const toggleOpenSnowflake = (forceOpen = false) => {
    setOpenBigquery(false);
    setOpenMysql(false);
    setOpenPostgre(false);
    setOpenRedshift(false);
    setOpenSqlserver(false);
    setOpenSnowflake(forceOpen === true ? true : !openSnowflake);
  };

  const handleOpen = (openId) => {
    switch (openId) {
      case 'bigquery':
        toggleOpenBigquery(true);
        break;
      case 'mysql':
        toggleOpenMysql(true);
        break;
      case 'postgresql':
        toggleOpenPostgre(true);
        break;
      case 'redshift':
        toggleOpenRedshift(true);
        break;
      case 'sql-server':
        toggleOpenSqlServer(true);
        break;
      case 'snowflake':
        toggleOpenSnowflake(true);
        break;
      default:
        break;
    }
  };

  const sortType = (category, tutorial) => {
    const tutorialType = tutorial.fields.type[0];

    switch (tutorialType) {
      case 'Basics':
        category[0].push(tutorial.fields);
        break;
      case 'Database Management':
        category[1].push(tutorial.fields);
        break;
      case 'Dates and Times':
        category[2].push(tutorial.fields);
        break;
      case 'Analysis':
        category[3].push(tutorial.fields);
        break;
      default:
        break;
    }
  };

  const filterPost = (tutorial) => {
    const dbCategory = tutorial.fields.category[0];

    switch (dbCategory.toLowerCase()) {
      case 'bigquery':
        sortType(data_bigquery, tutorial);
        break;
      case 'mysql':
        sortType(data_mysql, tutorial);
        break;
      case 'postgresql':
        sortType(data_postgresql, tutorial);
        break;
      case 'redshift':
        sortType(data_redshift, tutorial);
        break;
      case 'sql server':
        sortType(data_sqlserver, tutorial);
        break;
      case 'snowflake':
        sortType(data_snowflake, tutorial);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (data && id) {
      data.map((tutorial) => filterPost(tutorial));
      handleOpen(id);
      setMysql(data_mysql);
      setPostgresql(data_postgresql);
      setBigquery(data_bigquery);
      setRedshift(data_redshift);
      setSqlserver(data_sqlserver);
      setSnowflake(data_snowflake);
    }
  }, [id]);

  const selected = (slug) => router.asPath.includes(slug);
  const getSectionTitle = (posts) => posts[0] && posts[0].type[0];

  const renderSection = ({ children, withLink, href, asPath }) => {
    if (withLink)
      return (
        <Link href={href} asPath={asPath}>
          {children}
        </Link>
      );
    return children;
  };

  const sections = [
    {
      label: 'PostgreSQL',
      id: 'postgresql',
      posts: postgresql,
      onLabelClick: toggleOpenPostgre,
      isOpen: openPostgre,
    },
    {
      label: 'Redshift',
      id: 'redshift',
      posts: redshift,
      onLabelClick: toggleOpenRedshift,
      isOpen: openRedshift,
    },
    {
      label: 'MySQL',
      id: 'mysql',
      posts: mysql,
      onLabelClick: toggleOpenMysql,
      isOpen: openMysql,
    },
    {
      label: 'SQL Server',
      id: 'sql-server',
      posts: sqlserver,
      onLabelClick: toggleOpenSqlServer,
      isOpen: openSqlserver,
    },
    {
      label: 'BigQuery',
      id: 'bigquery',
      posts: bigquery,
      onLabelClick: toggleOpenBigquery,
      isOpen: openBigquery,
    },
    {
      label: 'Snowflake',
      id: 'snowflake',
      posts: snowflake,
      onLabelClick: toggleOpenSnowflake,
      isOpen: openSnowflake,
    },
  ];

  // return <h1>HELLO</h1>

  return (
    <aside className={`pl-5 ${className || ''}`}>
      <ol className={styles.tree__container}>
        {sections.map((section) => (
          <li
            key={`section-${section.id}`}
            className={`${styles.tree__item} mb-3`}
          >
            {/* PostgreSQL */}
            {renderSection({
              children: (
                <label
                  className={`${styles.tree__label} text-black hover:text-blue-100 text-s font-inter font-medium transition-colors duration-200 ease-in-out mb-2 flex items-center cursor-pointer py-2`}
                  onClick={section.onLabelClick}
                >
                  <div className="pr-1">
                    <i
                      className={`flex items-center justify-center w-7 h-7 transform text-gray-300 ${
                        !withSectionsOnly && section.isOpen ? 'rotate-90' : ''
                      }`}
                    >
                      <MdKeyboardArrowRight />
                    </i>
                  </div>
                  <p className="text-sm hover:text-blue-100 text-black leading-snug">
                    {section.label}
                  </p>
                </label>
              ),
              withLink: withSectionsOnly,
              href: ROUTES.learnPost(section.id).href,
              asPath: ROUTES.learnPost(section.id).asPath,
            })}
            {!withSectionsOnly &&
              section.posts.map((posts, postsIndex) => (
                <div
                  key={`post-${postsIndex}-${section.id}`}
                  className={styles.ol}
                  style={{ '--height': section.isOpen ? '1535px' : '0' }}
                >
                  <p className="text-gray-500 mt-2 mb-2 opacity-80 text-xs tracking-wider font-semibold font-inter uppercase">
                    {getSectionTitle(posts)}
                  </p>
                  <ol className="mb-4">
                    {posts.map((post, postIndex) => {
                      return (
                        <li key={postIndex} className="leading-4 mb-2">
                          <Link href={post.slug} asPath={post.slug}>
                            <a
                              className={`text-black hover:text-blue-100 text-xs font-inter transition-colors duration-100 ease-in-out py-1 block ${
                                selected(post.slug) && 'text-blue-100'
                              }`}
                            >
                              {post.title}
                            </a>
                          </Link>
                        </li>
                      );
                    })}
                  </ol>
                </div>
              ))}
          </li>
        ))}
      </ol>
    </aside>
  );
};

export default AsideLearn;
